﻿import { arrayOf, oneOfType, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const autoCompleteValueType = oneOfType([string, arrayOf(string)]);
